import { restHeartClient } from "..";

export function updateDocumentBatch(db: string, collection: string, filter: any, data: any) {
    return restHeartClient.patch(`${db}/${collection}/*`, data,{
        params: {
            filter: JSON.stringify(filter)
        }
    });
}
